import {getProductParamsTest} from "../../logic/setup/ProdcutParamsParser";
import {assertEqual} from "../../unittests/UnitTestHelper";
import {save} from "../../logic_tmp/appdata/AppData";
import {parseUrl} from "../../logic/setup/ParametersParser";


export function
testPricePageLogic() {
    let data = parseUrl({}, getProductParamsTest())
    assertEqual("PriceShouldNotBeNegative!", validatePrice(data, -1).code)
    assertEqual("NoCents", validatePrice(data, 1.1).code)
    data.product.flexParams.minPrice = 5
    let res = validatePrice(data, 3)
    assertEqual("PriceIsTooSmall", res.code)
    assertEqual(5, res.param.price)
    data.product.flexParams.minPrice = 0
    assertEqual("OK", validatePrice(data, 0).code)
    assertEqual("noFixedPriceInclZeroForRecording", validatePrice(data, "").code)
    assertEqual(undefined, submitPrice(data, -1))
    assertEqual("/lead", submitPrice(data, 1))
    assertEqual(1, data.priceFull)

}

export function submitPrice(data, price) {

    if (validatePrice(data, price).code !== "OK") return undefined
    data.priceFull = price * 1;
    data.amount = price * 1;
    if ("OFFLINE" === data.product.type)
        return "/amt"
    else {
        data.count = 1
        data.countFull = 1
        return "/lead"
    }
}



export function validatePrice(data, val) {
    if (val === undefined || val.toString().length < 1) {
        if (data.product.flexParams.priceEmptyMessage !== undefined)
            return {code: data.product.flexParams.priceEmptyMessage}
        return {code: "PleaseSelectPriceOfTicket"}
    }
    if (val < 0)
        return {code: "PriceShouldNotBeNegative!"}
    if (val % 1 !== 0)
        return {code: "NoCents"}
    if (val < data.product.flexParams.minPrice)
        return {code: "PriceIsTooSmall", param: {price: data.product.flexParams.minPrice}}
    return {code: "OK"}
}

